import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="August 2024 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Research Assistant (Wissenschaftliche Hilfskraft)</h2>
            <h3 className="vertical-timeline-element-title">
              <a href="https://rc-trust.ai/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', fontSize: '1rem' }}>Research Center Trustworthy Data Science and Security</a>
            </h3>
            <h6 className="vertical-timeline-element-subtitle">Dortmund, Germany</h6>
            <p><ul>
              <li>Contributed to research on <strong>large language models (LLMs)</strong>, supporting AI-driven advancements in data security and trustworthiness with cutting-edge machine learning techniques.</li>
              <li>Developed and optimized Python scripts for automating <strong>data analysis, model training, and testing</strong>, boosting efficiency and experimental precision in trustworthy AI research.</li>
            </ul></p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="August 2024 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Research Assistant (Wissenschaftliche Hilfskraft)</h2>
            <h3 className="vertical-timeline-element-title">
              <a href="https://vm.cs.tu-dortmund.de/team/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', fontSize: '1rem' }}>Virtual Machining Department - TU Dortmund</a>
            </h3>
            <h6 className="vertical-timeline-element-subtitle">Dortmund, Germany</h6>
            <p><ul>
              <li>I model sensor data from a milling machine using time series analysis methods to predict the vibrations occurring at each point in time.</li>
              <li>Utilized <strong>Python with Randomforest and XgBoost</strong> to model and predict machine vibrations, enhancing predictive maintenance capabilities.</li>
            </ul></p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="November 2023 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Student Software Engineer</h2>
            <h3 className="vertical-timeline-element-title">
              <a href="https://www.ukm.de/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', fontSize: '1rem' }}>Universitätsklinikum Münster</a>
            </h3>
            <h6 className="vertical-timeline-element-subtitle">Münster, Germany</h6>
            <p>
              <ul>
                <li><strong>Java Spring Boot, Hibernate, MySQL, GitLab CI/CD:</strong> Enhanced and optimized MoPat, an open-source medical questionnaire app, improving scalability, security, and user engagement.</li>
                <li><strong>Thymeleaf, JavaScript, jQuery, SCSS:</strong> Developed responsive, accessible interfaces for cross-device compatibility.</li>
                <li>Led backend and frontend updates, streamlining caching and security to boost application
                  performance.</li>
              </ul>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="February 2022 - November 2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h2 className="vertical-timeline-element-title">Software Engineer</h2>
            <h3 className="vertical-timeline-element-title">
              <a href="http://www.folio3.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'black', fontSize: '1rem' }}>Folio3 Software</a>
            </h3>
            <h6 className="vertical-timeline-element-subtitle">Karachi, Pakistan</h6>
            <p><ul>
              <li>Developed and optimized front-end applications with <strong>React.js</strong> and <strong>Angular</strong>, alongside scalable microservices with <strong>Node.js</strong>, <strong>MySQL</strong>, and <strong>Express.js</strong> for B2B e-commerce and fintech solutions.</li>
              <li>Enhanced application performance and code quality through daily optimization, automated testing, and efficient build configurations (<strong>Webpack</strong> & <strong>Rollup</strong>), reducing post-deployment issues by 30%.</li>
              <li>Led a team of two engineers on a client project, conducted code reviews, and facilitated tech talks, mentoring associates and interns to foster growth and innovation.</li>
            </ul></p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;